import {apiUrl} from "../definitions";

export default async function fetchVehicles(fetch){
    const requestOptions = {
        method: 'GET',
    };
    return await fetch(`${apiUrl}/fms/vehicles`, requestOptions);
}
